"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paletteToRGBA = paletteToRGBA;
exports.paletteWithLastTransToRGBA = paletteWithLastTransToRGBA;
function paletteToRGBA(pixels, palette) {
    const rgba = new Uint8Array(pixels.length * 4);
    const len = pixels.length;
    for (let i = 0; i < len; ++i) {
        rgba[i * 4] = palette[pixels[i] * 3];
        rgba[i * 4 + 1] = palette[pixels[i] * 3 + 1];
        rgba[i * 4 + 2] = palette[pixels[i] * 3 + 2];
        rgba[i * 4 + 3] = 255;
    }
    return rgba;
}
function paletteWithLastTransToRGBA(pixels, palette) {
    const rgba = new Uint8Array(pixels.length * 4);
    const len = pixels.length;
    for (let i = 0; i < len; ++i) {
        if (pixels[i] === 255) {
            rgba[i * 4 + 3] = 0;
        }
        else {
            rgba[i * 4] = palette[pixels[i] * 3];
            rgba[i * 4 + 1] = palette[pixels[i] * 3 + 1];
            rgba[i * 4 + 2] = palette[pixels[i] * 3 + 2];
            rgba[i * 4 + 3] = 255;
        }
    }
    return rgba;
}
